import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { PrivateRoute, checkPermission } from '../../../utils/route-auth';
import { PERMISSION } from '../../../constants/permission';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import routes from '../../../routes';
import { checkConnectionManagementAccess } from '../../../selectors';

const Views = asyncRoute(() => import('./Views'));

const ConnectionManagement = (props) => {
    const isSigningIn = localStorage.getItem('isSigningIn');

    return (
        <>
        {
          Number(isSigningIn) ?
            <>
            </>
            :
            <Switch>
                {
                    checkPermission({ permissions: [PERMISSION.ADMIN.CONNECTIONMANAGEMENT.VIEW] }) && checkConnectionManagementAccess() ?
                        <Route exact path={props.match.path} component={Views} />
                        :
                        <Redirect to={{
                            pathname: `${routes.admin.account.name}`,
                        }} />
                }
            </Switch>
        }
        </>
    )
};

export default ConnectionManagement;
